/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_551d0a17',
  dropdown: 'dropdown_551d0a17',
};

export = styles;

loadStyles([{"rawString":".root_551d0a17{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.root_551d0a17 .dropdown_551d0a17{margin-bottom:0;margin-left:5px}"}]);
/* tslint:enable */